export default "__VITE_ASSET__BdfH8_71__"